module.exports = __webpack_public_path__ + "img/icon_home_gk.65490672.png";